(function() {
    'use strict';

    angular
        .module('bhsApp')
        .controller('TableauClassementAccidentsController', TableauClassementAccidentsController);

    TableauClassementAccidentsController.$inject = ['$scope', '$state', 'ParseLinks', 'AlertService'];

    function TableauClassementAccidentsController ($scope, $state, ParseLinks, AlertService) {


    }
})();
